import DisponibilidadeForm from './DisponibilidadeForm';

export default DisponibilidadeForm;
